import memoizeOne from 'memoize-one';
import { createSelector } from 'reselect';

import searchItems from 'utils/searchItems';

import { getDebouncedSearchValue } from 'store/search/selectors';

import { getSystem } from './system.selectors';

const selectDenialReasons = createSelector(getSystem, ({ denialReasons }) => denialReasons || {});

export const selectDenialReasonsData = createSelector(
  selectDenialReasons,
  ({ data }) => data || {},
);

export const selectHMDACodeOptions = createSelector(selectDenialReasons, ({ HMDACodes }) =>
  HMDACodes.map(({ hmdaCode, title }) => ({ name: title, value: hmdaCode })),
);

export const selectHMDACodeMap = createSelector(selectDenialReasons, ({ HMDACodes }) =>
  HMDACodes.reduce((acc, { hmdaCode, title }) => {
    acc[hmdaCode] = title;

    return acc;
  }, {}),
);

export const selectDenialReasonsList = createSelector(selectDenialReasonsData, Object.values);

export const selectDenialReasonsOptions = createSelector(selectDenialReasonsList, list =>
  list.map(({ id, name }) => ({ value: id, name })),
);

export const selectDenialReasonById = memoizeOne(denialReasonId =>
  createSelector(selectDenialReasonsData, denialReasonsData => denialReasonsData[denialReasonId]),
);

export const selectFilteredDenialReasonsList = createSelector(
  [getDebouncedSearchValue, selectDenialReasonsList],
  searchItems(({ id, name }) => [id, name]),
);
